var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 19H5c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1M11.3 16.7c.1.1.2.2.3.2s.2.1.4.1c.1 0 .3 0 .4-.1s.2-.1.3-.2l5-5c.4-.4.4-1 0-1.4s-1-.4-1.4 0L13 13.6V4c0-.6-.4-1-1-1s-1 .4-1 1v9.6l-3.3-3.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4z"
})));
export default SvgIcDownload;